// Only the scenery on screen is drawn (review 2026-09-30: ~2300 props were submitted every frame).
// Pure: the FarmWorld container's pan/zoom → the local rect on screen, and whether a prop touches it.

// The container draws local (lx, ly) at screen (x + lx·scale, y + ly·scale).
export function localViewRect({ x, y, scale }, viewport, pad = 0) {
  return {
    x0: -x / scale - pad, y0: -y / scale - pad,
    x1: (viewport.w - x) / scale + pad, y1: (viewport.h - y) / scale + pad,
  };
}

// A sprite anchored at its bottom-centre (x, y), w × h.
export function spriteInView({ x, y, w, h }, r) {
  return x + w / 2 >= r.x0 && x - w / 2 <= r.x1 && y >= r.y0 && y - h <= r.y1;
}
